import { cn } from '@/utils/format';

type TypeBadgeProps = {
  label: string | null | undefined;
};

// A neutral, readable badge for the org/event type shown on a card.
export const TypeBadge = ({ label }: TypeBadgeProps) => {
  if (!label) return null;

  return (
    <span
      className={cn(
        'inline-flex rounded-full bg-muted px-2 py-0.5 text-xs font-medium text-muted-foreground',
      )}
    >
      {label}
    </span>
  );
};
